export default __webpack_public_path__ + "fa3b61d41c3a9fd619929d151d0acc5a.jpg";